import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../../lib/api";
import { Plus, Edit2, Trash2 } from "lucide-react";
import { toast } from "sonner";

const AdminBlog = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    api.get("/admin/blog").then((r) => setItems(r.data || [])).catch(() => {}).finally(() => setLoading(false));
  };
  useEffect(load, []);

  const remove = async (id) => {
    if (!window.confirm("Delete this post?")) return;
    try { await api.delete(`/admin/blog/${id}`); toast.success("Deleted"); load(); }
    catch { toast.error("Failed"); }
  };

  return (
    <div data-testid="admin-blog">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="font-display text-3xl font-black tracking-tight">Blog posts</h1>
          <p className="text-sm text-zinc-500 mt-1">{items.length} total</p>
        </div>
        <Link to="/admin/blog/new" data-testid="admin-blog-new" className="bg-orange-500 hover:bg-orange-600 text-white font-semibold px-5 py-2.5 rounded-md inline-flex items-center gap-2">
          <Plus size={16} /> New post
        </Link>
      </div>

      <div className="mt-8 bg-white border border-zinc-200 rounded-md">
        {loading ? (
          <div className="p-10 text-center text-zinc-500 text-sm">Loading…</div>
        ) : items.length === 0 ? (
          <div className="p-10 text-center text-zinc-500 text-sm">No posts yet.</div>
        ) : (
          <div className="divide-y divide-zinc-100">
            {items.map((p) => (
              <div key={p.id} className="px-6 py-4 flex items-center justify-between gap-4">
                <div>
                  <div className="font-semibold text-zinc-900">{p.title}</div>
                  <div className="text-xs text-zinc-500 mt-1">/{p.slug} · {new Date(p.created_at).toLocaleDateString()}</div>
                </div>
                <div className="flex items-center gap-2">
                  <Link to={`/admin/blog/${p.id}`} className="p-2 rounded-md hover:bg-zinc-100 text-zinc-600"><Edit2 size={16} /></Link>
                  <button onClick={() => remove(p.id)} className="p-2 rounded-md hover:bg-red-50 text-red-600"><Trash2 size={16} /></button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminBlog;
